import React, { useState, useRef,useEffect } from "react";
import {
  Container,
  Card,
  CardContent,
  makeStyles,
  Grid,
} from "@material-ui/core";
import QrReader from "react-qr-reader";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import axios from "axios";
import MODAL_TABLE from "../../main_components/modal/modal_Table";
import BottomNavigation from "@mui/material/BottomNavigation";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

// console.log(socioNegocioNuevo);
import { useDialog } from "react-st-modal";
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
              backgroundImage: `url('data:image/svg+xml;base64,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')`,

      },
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'white' : 'white',
    width: 32,
    height: 32,
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iMjAiIGhlaWdodD0iMjAiCnZpZXdCb3g9IjAgMCA1MCA1MCIKc3R5bGU9ImZpbGw6IzQwQzA1NzsiPgo8cGF0aCBkPSJNIDIyLjc4MTI1IDAgQyAyMS42MDU0NjkgLTAuMDAzOTA2MjUgMjAuNDA2MjUgMC4xNjQwNjMgMTkuMjE4NzUgMC41MzEyNSBDIDEyLjkwMjM0NCAyLjQ5MjE4OCA5LjI4OTA2MyA5LjI2OTUzMSAxMS4yNSAxNS41OTM3NSBMIDExLjI1IDE1LjY1NjI1IEMgMTEuNTA3ODEzIDE2LjM2NzE4OCAxMi4xOTkyMTkgMTguNjE3MTg4IDEyLjYyNSAyMCBMIDkgMjAgQyA3LjMwMDc4MSAyMCA2IDIxLjMwMDc4MSA2IDIzIEwgNiA0NyBDIDYgNDguNjk5MjE5IDcuMzAwNzgxIDUwIDkgNTAgTCA0MSA1MCBDIDQyLjY5OTIxOSA1MCA0NCA0OC42OTkyMTkgNDQgNDcgTCA0NCAyMyBDIDQ0IDIxLjMwMDc4MSA0Mi42OTkyMTkgMjAgNDEgMjAgTCAxNC43NSAyMCBDIDE0LjQ0MTQwNiAxOS4wMDc4MTMgMTMuNTExNzE5IDE2LjA3NDIxOSAxMy4xMjUgMTUgTCAxMy4xNTYyNSAxNSBDIDExLjUxOTUzMSA5LjcyMjY1NiAxNC41IDQuMTA5Mzc1IDE5Ljc4MTI1IDIuNDY4NzUgQyAyNS4wNTA3ODEgMC44MzIwMzEgMzAuNjk1MzEzIDMuNzk2ODc1IDMyLjM0Mzc1IDkuMDYyNSBDIDMyLjM0Mzc1IDkuMDY2NDA2IDMyLjM0Mzc1IDkuMDg5ODQ0IDMyLjM0Mzc1IDkuMDkzNzUgQyAzMi41NzAzMTMgOS44ODY3MTkgMzMuNjU2MjUgMTMuNDA2MjUgMzMuNjU2MjUgMTMuNDA2MjUgQyAzMy43NDYwOTQgMTMuNzY1NjI1IDM0LjAyNzM0NCAxNC4wNTA3ODEgMzQuMzg2NzE5IDE0LjEzNjcxOSBDIDM0Ljc1IDE0LjIyNjU2MyAzNS4xMjg5MDYgMTQuMTA5Mzc1IDM1LjM3NSAxMy44MzIwMzEgQyAzNS42MjEwOTQgMTMuNTUwNzgxIDM1LjY5NTMxMyAxMy4xNjAxNTYgMzUuNTYyNSAxMi44MTI1IEMgMzUuNTYyNSAxMi44MTI1IDM0LjQzMzU5NCA5LjE3MTg3NSAzNC4yNSA4LjUzMTI1IEwgMzQuMjUgOC41IEMgMzIuNzgxMjUgMy43NjE3MTkgMjguNjAxNTYzIDAuNTQyOTY5IDIzLjkzNzUgMC4wNjI1IEMgMjMuNTUwNzgxIDAuMDIzNDM3NSAyMy4xNzE4NzUgMCAyMi43ODEyNSAwIFogTSAyNSAzMCBDIDI2LjY5OTIxOSAzMCAyOCAzMS4zMDA3ODEgMjggMzMgQyAyOCAzMy44OTg0MzggMjcuNjAxNTYzIDM0LjY4NzUgMjcgMzUuMTg3NSBMIDI3IDM4IEMgMjcgMzkuMTAxNTYzIDI2LjEwMTU2MyA0MCAyNSA0MCBDIDIzLjg5ODQzOCA0MCAyMyAzOS4xMDE1NjMgMjMgMzggTCAyMyAzNS4xODc1IEMgMjIuMzk4NDM4IDM0LjY4NzUgMjIgMzMuODk4NDM4IDIyIDMzIEMgMjIgMzEuMzAwNzgxIDIzLjMwMDc4MSAzMCAyNSAzMCBaIj48L3BhdGg+Cjwvc3ZnPg==')`,
    },
  },
  '& .MuiSwitch-track': {
    backgroundColor: theme.palette.mode === 'dark' ? 'white' : 'white',
    borderRadius: 20 / 2,
  },
}));

function Update_bussines_p(props) {
  const dialog = useDialog();

  // const [text, setText] = useState('');
  // const [imageUrl, setImageUrl] = useState('');
  const [scanResultFile, setScanResultFile] = useState("Sin resultados");
  const [scanResultWebCam, setScanResultWebCam] = useState("Sin resultados");
  const classes = useStyles();
  const qrRef = useRef(null);
  const [registergeneral, setRegisterGeneral] = useState(false);
  const [registerBussnes, setregisterBussnes] = useState(false);
  const [modalT, setmodalT] = useState(false);
  const [value, setValue] = React.useState(0);

  
  const [business_partnerUp, setbusiness_partnerUp] = useState('');
  const [rfcUp, setrfcUp] = useState('');
  const [nameUp, setnameUp] = useState('');
  const [first_last_nameUp, setfirst_last_nameUp] = useState('');
  const [second_last_nameUp, setsecond_last_nameUp] = useState('');
  const [tax_regimeUp, settax_regimeUp] = useState('');
  const [capital_regimeUp, setcapital_regimeUp] = useState('');
  const [emailUp, setemailUp] = useState('');
  const [streetUp, setstreetUp] = useState('');
  const [outdoor_numberUp, setoutdoor_numberUp] = useState('');
  const [inside_numberUp, setinside_numberUp] = useState('');
  const [neighborhoodUp, setneighborhoodUp] = useState('');
  const [zip_codeUp, setzip_codeUp] = useState('');
  const [cityUp, setcityUp] = useState('');
  const [stateUp, setstateUp] = useState('');

  useEffect(() => {
    setbusiness_partnerUp(business_partnerUp);
    setrfcUp(rfcUp);
    setnameUp(nameUp);
    setfirst_last_nameUp(first_last_nameUp);
    setsecond_last_nameUp(second_last_nameUp);
    settax_regimeUp(tax_regimeUp);
    setcapital_regimeUp(capital_regimeUp);
    setemailUp(emailUp);
    setstreetUp(streetUp);
    setoutdoor_numberUp(outdoor_numberUp);
    setinside_numberUp(inside_numberUp);
    setneighborhoodUp(neighborhoodUp);
    setzip_codeUp(zip_codeUp);
    setcityUp(cityUp);
    setstateUp(stateUp);

  }, []);
  

  
  const handleErrorFile = () => {
  };
  const handleScanFile = (result) => {
    if (result) {
      var data = JSON.stringify({
        url: result,
      });
      setmodalT(true);
      var config = {
         method: "put",
         url: "https://m0fsi6ifd9.execute-api.us-east-1.amazonaws.com/development/businesspartners",
         headers: {
           Authorization: sessionStorage.getItem("getIdTokenRefresh"),
           "access-token": sessionStorage.getItem("getAccesTokenRefresh"),
           "Content-Type": "application/json",
         },
        data: data,
      };

      axios(config)
        .then(function (response) {
          setScanResultFile(JSON.stringify(response.data));
          setmodalT(false);
          alert("Código escaneado");
        })
        .catch(function (error) {

          props.setbussnespartner(error?.response?.data?.business_partner?.business_partner);
          props.setnamepartner(error?.response?.data?.business_partner?.name);
          props.setfirstlastname(error?.response?.data?.business_partner?.first_last_name);
          props.setsecondlastname(error?.response?.data?.business_partner?.second_last_name);
          props.setrfc(error?.response?.data?.business_partner?.rfc);
          props.setemail(error?.response?.data?.business_partner?.email);
          props.setstreet(error?.response?.data?.address?.street);
          props.setoutdoornumber(error?.response?.data?.address?.outdoor_number);
          props.setinsidenumber(error?.response?.data?.address?.inside_number);
          props.setneighborhood(error?.response?.data?.address?.neighborhood);
          props.setzipcode(error?.response?.data?.address?.zip_code);
          props.setcity(error?.response?.data?.address?.city);
          props.setstate(error?.response?.data?.address?.state);
          props.setpersontype((error?.response?.data?.business_partner?.rfc).length===13?"FISICA":"MORAL")
          props.settax_regime(error?.response?.data?.business_partner?.tax_regime)
          props.setcapital_regime(error?.response?.data?.business_partner?.capital_regime)


          props.setvsocio(false);
          props.setvrfc(false);
          props.setvname(false);
          props.setvsname(false);
          props.setvfname(false);
          props.setvmail(false);
    
          props.setvstreet(false);
          props.setvoutdoor(false);
          props.setvneigh(false);
          props.setvzip(false);
          props.setvcity(false);
          props.setvstate(false);
          
          sessionStorage.setItem(
            "business_partner",
            error?.response?.data?.business_partner?.business_partner
          );
          sessionStorage.setItem(
            "capital_regime",
            error?.response?.data?.business_partner?.capital_regime
          );
          sessionStorage.setItem(
            "email",
            error?.response?.data?.business_partner?.email
          );
          sessionStorage.setItem(
            "first_last_name",
            error?.response?.data?.business_partner?.first_last_name
          );
          sessionStorage.setItem(
            "name",
            error?.response?.data?.business_partner?.name
          );
          sessionStorage.setItem(
            "rfc",
            error?.response?.data?.business_partner?.rfc
          );
          sessionStorage.setItem(
            "second_last_name",
            error?.response?.data?.business_partner?.second_last_name
          );
          sessionStorage.setItem(
            "tax_regime",
            error?.response?.data?.business_partner?.tax_regime
          );
          sessionStorage.setItem("city", error?.response?.data?.address?.city);
          sessionStorage.setItem(
            "inside_number",
            error?.response?.data?.address?.inside_number
          );
          sessionStorage.setItem(
            "neighborhood",
            error?.response?.data?.address?.neighborhood
          );
          sessionStorage.setItem(
            "outdoor_number",
            error?.response?.data?.address?.outdoor_number
          );
          sessionStorage.setItem(
            "state",
            error?.response?.data?.address?.state
          );
          sessionStorage.setItem(
            "street",
            error?.response?.data?.address?.street
          );
          sessionStorage.setItem(
            "zip_code",
            error?.response?.data?.address?.zip_code
          );

          try {
            setScanResultFile(error?.response?.data?.message);

            setmodalT(false);
            setRegisterGeneral(error?.response?.data?.business_partner?.business_partner.length>3?true:false);
          } catch (error) {
            alert("Escanear denuevo");
          }
        });
    }
  };
  const onScanFile = () => {
    qrRef.current.openImageDialog();
  };
  const handleErrorWebCam = (error) => {
    console.log(error);
  };
  const handleScanWebCam = (result) => {

    if (result) {
      var url = { url: result };  
      setmodalT(true);

      var data = JSON.stringify({
        url: result,
      });


      console.log(data);

      var config = {
        method: "put",
         url: "https://m0fsi6ifd9.execute-api.us-east-1.amazonaws.com/development/businesspartners",
         headers: {
           Authorization: sessionStorage.getItem("getIdTokenRefresh"),
           "access-token": sessionStorage.getItem("getAccesTokenRefresh"),
           "Content-Type": "application/json",
         },
         data: data,
      };

      axios(config)
        .then(function (response) {
          setScanResultWebCam(JSON.stringify(response.data));
          setmodalT(false);
        })
        .catch(function (error) {


          props.setbussnespartner(error?.response?.data?.business_partner?.business_partner);
          props.setnamepartner(error?.response?.data?.business_partner?.name);
          props.setfirstlastname(error?.response?.data?.business_partner?.first_last_name);
          props.setsecondlastname(error?.response?.data?.business_partner?.second_last_name);
          props.setrfc(error?.response?.data?.business_partner?.rfc);
          props.setemail(error?.response?.data?.business_partner?.email);
          props.setstreet(error?.response?.data?.address?.street);
          props.setoutdoornumber(error?.response?.data?.address?.outdoor_number);
          props.setinsidenumber(error?.response?.data?.address?.inside_number);
          props.setneighborhood(error?.response?.data?.address?.neighborhood);
          props.setzipcode(error?.response?.data?.address?.zip_code);
          props.setcity(error?.response?.data?.address?.city);
          props.setstate(error?.response?.data?.address?.state);
          props.setpersontype((error?.response?.data?.business_partner?.rfc).length===13?"FISICA":"MORAL");
          props.settax_regime(error?.response?.data?.business_partner?.tax_regime);
          props.setcapital_regime(error?.response?.data?.business_partner?.capital_regime);

          
          props.setvsocio(false);
          props.setvrfc(false);
          props.setvname(false);
          props.setvsname(false);
          props.setvfname(false);
          props.setvmail(false);
    
          props.setvstreet(false);
          props.setvoutdoor(false);
          props.setvneigh(false);
          props.setvzip(false);
          props.setvcity(false);
          props.setvstate(false);

          console.log(error?.response?.data?.business_partner);
          
          sessionStorage.setItem(
            "business_partner",
            error?.response?.data?.business_partner?.business_partner
          );
          sessionStorage.setItem(
            "capital_regime",
            error?.response?.data?.business_partner?.capital_regime
          );
          sessionStorage.setItem(
            "email",
            error?.response?.data?.business_partner?.email
          );
          sessionStorage.setItem(
            "first_last_name",
            error?.response?.data?.business_partner?.first_last_name
          );
          sessionStorage.setItem(
            "name",
            error?.response?.data?.business_partner?.name
          );
          sessionStorage.setItem(
            "rfc",
            error?.response?.data?.business_partner?.rfc
          );
          sessionStorage.setItem(
            "second_last_name",
            error?.response?.data?.business_partner?.second_last_name
          );
          sessionStorage.setItem(
            "tax_regime",
            error?.response?.data?.business_partner?.tax_regime
          );
          sessionStorage.setItem("city", error?.response?.data?.address?.city);
          sessionStorage.setItem(
            "inside_number",
            error?.response?.data?.address?.inside_number
          );
          sessionStorage.setItem(
            "neighborhood",
            error?.response?.data?.address?.neighborhood
          );
          sessionStorage.setItem(
            "outdoor_number",
            error?.response?.data?.address?.outdoor_number
          );
          sessionStorage.setItem(
            "state",
            error?.response?.data?.address?.state
          );
          sessionStorage.setItem(
            "street",
            error?.response?.data?.address?.street
          );
          sessionStorage.setItem(
            "zip_code",
            error?.response?.data?.address?.zip_code
          );

          try {
            setScanResultWebCam(error?.response?.data?.message);
            setmodalT(false);
            setRegisterGeneral(error?.response?.data?.business_partner?.business_partner.length>3?true:false);
          } catch (error) {
            alert("Escanear denuevo");
          }
        });
    }
  };

  const handleRedirect =()=>{
    setregisterBussnes(true);
    window.location="/createQr";

  }

  const handleRedirectPoint =()=>{
    // setregisterBussnes(true);
    // window.location="/createQrPonint";
    dialog.close();

  }

  const [checkedGeneral, setcheckedGeneral] = React.useState(true);
  const handlechecked=(event)=>{
    setcheckedGeneral(event.target.checked);
    console.log(event.target.checked);

  }

  return (
    <div>
     <MODAL_TABLE
        open={true}
        message={""}
        modalT={modalT}
      ></MODAL_TABLE>
        <div style={{display:registerBussnes===false?"":"none"}}>
        <Box sx={{ margin: "0 auto", width: "100%" }}>
        <BottomNavigation
          showlabel
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <div className="switchRegister">
          <FormControlLabel
            control={<MaterialUISwitch sx={{ m: 1 }} onChange={handlechecked} checked={checkedGeneral} />}
            label={checkedGeneral===true?"ESCANEAR POR IMAGEN":"ESCANEAR POR CAMARA"}
          />
           </div>
        </BottomNavigation>
        
      </Box>
          <Container className={classes.conatiner}>
            <Card>
              <CardContent>
                <Grid container justifyContent="space-around" spacing={1}>
                   <Grid item xl={4} lg={4} md={6} sm={12} xs={12} style={{display:checkedGeneral===true?"none":""}}>
                        <Button className={classes.btn} variant="contained" onClick={onScanFile}>Selecciona el QR a Escanear</Button>
                        <QrReader
                          ref={qrRef}
                          delay={300}
                          style={{width: '100%'}}
                          onError={handleErrorFile}
                          onScan={handleScanFile}
                          legacyMode
                        />
                        <h3>Código escaneado: {scanResultFile}</h3>
                      </Grid> 
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12} style={{display:checkedGeneral===true?"":"none"}}>
                    <QrReader
                      delay={1000}
                      style={{ width: "100%" }}
                      onError={handleErrorWebCam}
                      onScan={handleScanWebCam}
                    />
                    <h3 className="ResponseCodeQR">Código escaneado: {scanResultWebCam}</h3>
                  </Grid>
                </Grid>
              </CardContent>
              <div className="importanMax">
                
              <Box style={{display:registergeneral===true?"":"none"}}>
                <Button
                  onClick={handleRedirect}
                  sx={{ m: 2, width: "40%" }}
                  variant="contained"
                  style={{ background: "#5e5cd7" }}
                >
                  REGISTRAR NUEVO SOCIO
                </Button>

                <Button
                  onClick={handleRedirectPoint}
                  sx={{ m: 2, width: "43%" }}
                  variant="contained"
                  style={{ background: "#5e5cd7" }}
                >
                  REGISTRAR NUEVO SOCIO Y PUNTO DE VENTA
                </Button>

              </Box>
              <Box>
                <Button
                  onClick={() => {
                    dialog.close(true);
                  }}
                  sx={{ m: 2, width: "40%" }}
                  variant="contained"
                  style={{ background: "green" }}
                >
                  Actualizar Tabla
                </Button>

                <Button
                  onClick={() => {
                   
                    props.setbussnespartner(null);
                    props.setnamepartner(null);
                    props.setfirstlastname(null);
                    props.setsecondlastname(null);
                    props.setrfc(null);
                    props.setemail(null);
                    props.setstreet(null);
                    props.setoutdoornumber(null);
                    props.setinsidenumber(null);
                    props.setneighborhood(null);
                    props.setzipcode(null);
                    props.setcity(null);
                    props.setstate(null);
                    props.setpersontype(" ");
                    props.setcapital_regime(null);
                    props.settax_regime("");
                    dialog.close();
                  }}
                  sx={{ m: 2, width: "43%" }}
                  variant="contained"
                  style={{ background: "red" }}
                >
                  CANCELAR
                </Button>
              </Box>
              </div>
            </Card>
          </Container>
        </div>


      
    </div>
  );
}

const useStyles = makeStyles(() => ({
  conatiner: {
    marginTop: 40,
  },
  title: {
    display: "flex",
    alignItems: "center",
    background: "#3f51b5",
    color: "#fff",
    padding: 20,
    textAlign: "center",
  },
  btn: {
    marginTop: 10,
    marginBottom: 20,
  },
}));
export default Update_bussines_p;
